module.exports = {"230208001":"梅里斯街道","230208101":"雅尔塞镇","230208102":"卧牛吐达斡尔族镇","230208103":"达呼店镇","230208104":"共和镇","230208105":"梅里斯镇","230208200":"莽格吐达斡尔族乡","230208501":"哈拉海农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230208.json
// module id = 639
// module chunks = 0